import React from 'react'
import { animateScroll as scroll } from 'react-scroll'
import { ArrowUpCircle } from 'react-bootstrap-icons'

const scrollToTop = () => {
  scroll.scrollToTop({
    duration: 200,
    behavior: 'smooth',
  })
}

type Props = {
  isDisplay: boolean
}
const defaultProps: Props = {
  isDisplay: false,
}

const ScrollToPageTopBtn = React.memo(
  (props: Props = defaultProps): React.JSX.Element => {
    const defaultCssClass = 'scrollToTopBtn'
    const cssClass: string = props.isDisplay
      ? `${defaultCssClass} isDisplay`
      : `${defaultCssClass}`

    return (
      <>
        <div onClick={scrollToTop} className={cssClass}>
          <ArrowUpCircle
            className="scrollToTopBtn__button"
          />
        </div>
      </>
    )
  },
)

export default ScrollToPageTopBtn
